import { z } from 'zod';
import { HIGHWAY_MAINTENANCE_FEE_STATE_VALUE } from './highwayMaintenanceFeeTicketState';

const HighwayMaintenanceFeeTicketAccountSchema = z.object({
  id: z.string(),
  email: z.string(),
});

const HighwayMaintenanceFeeTicketOperatorNoteSchema = z.object({
  id: z.string(),
  operator: z.string(),
  content: z.string(),
  createDateTime: z.string(),
});

const HighwayMaintenanceFeeTicketSchema = z.object({
  id: z.string(),
  hmfAutoPayEnrollmentId: z.string(),
  account: HighwayMaintenanceFeeTicketAccountSchema,
  plateNumber: z.string(),
  idNumber: z.string().nullable().default(null),
  taxIdNumber: z.string().nullable().default(null),
  state: z.enum(HIGHWAY_MAINTENANCE_FEE_STATE_VALUE),
  amount: z.number().nullable().default(null),
  paymentId: z.string().nullable().default(null),
  completeDateTime: z.string().nullable().default(null),
  createDateTime: z.string(),
  updateDateTime: z.string(),
  reason: z.string().nullable().default(null),
  operatorNotes: z
    .array(HighwayMaintenanceFeeTicketOperatorNoteSchema)
    .default([]),
});

const HighwayMaintenanceFeeTicketSummarySchema =
  HighwayMaintenanceFeeTicketSchema.omit({
    operatorNotes: true,
  });

type HighwayMaintenanceFeeTicketAccount = z.infer<
  typeof HighwayMaintenanceFeeTicketAccountSchema
>;
type HighwayMaintenanceFeeTicketOperatorNote = z.infer<
  typeof HighwayMaintenanceFeeTicketOperatorNoteSchema
>;
type HighwayMaintenanceFeeTicket = z.infer<
  typeof HighwayMaintenanceFeeTicketSchema
>;
type HighwayMaintenanceFeeTicketSummary = z.infer<
  typeof HighwayMaintenanceFeeTicketSummarySchema
>;

export {
  HighwayMaintenanceFeeTicketAccountSchema,
  HighwayMaintenanceFeeTicketOperatorNoteSchema,
  HighwayMaintenanceFeeTicketSchema,
  HighwayMaintenanceFeeTicketSummarySchema,
};

export type {
  HighwayMaintenanceFeeTicketAccount,
  HighwayMaintenanceFeeTicketOperatorNote,
  HighwayMaintenanceFeeTicket,
  HighwayMaintenanceFeeTicketSummary,
};
